import { useAppSelector } from 'app/hooks';
import {
  getSystemDesignBypassMode,
  SystemDesignBypassMode
} from 'utils/system-design-bypass';

// Reactive System Design bypass mode (utils/system-design-bypass): re-derives
// from system_preference, the existing systems and, for the hybrid case,
// from the structure's user-placed rooms — the same inputs as
// useHybridLeftoverSpaceIds.
export default function useSystemDesignBypassMode(): SystemDesignBypassMode | null {
  return useAppSelector((state) =>
    getSystemDesignBypassMode({
      systemPreference: state.project.projectSettings.find(
        (ps) => ps.code === 'system_preference'
      )?.value,
      structure: Array.isArray(state.structure.structure)
        ? state.structure.structure
        : [],
      existingSystems: state.structure.existingSystems,
      autoLayoutSpaceIds: state.structure.autoLayoutSpaceIds ?? []
    })
  );
}
